<template>
  <footer class="zk-footer">
    <div class="copyright">
      <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备20059828号-2</a>
      <img src="//www.myzaker.com/images/new/bottom/ga.png"
               style="float:left; margin: 0 5px 0 0px;" />
      <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44010602009154" target="_blank">粤公网安备 44010602009154号</a>
    </div>
    <a class="email" href="mailto:support@myzaker.com">举报邮箱：yu998926@163.com</a>
  </footer>
</template>

<script>
export default {

}
</script>

<style lang="less">
.zk-footer {
  margin: auto;
  width: 680px;
  font-size: 12px;
  color: #ABABAB;
  text-align: center;

  .email {
    display: block;
    padding-top: 12px;
    padding-bottom: 30px;
    color: inherit;
  }
}

.footer-title {
  padding: 20px 0;
  border-bottom: 1px solid #E8E8E8;
}

.copyright {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 26px;
  border-top: 1px solid #E8E8E8;
  
  a {
    color: #ABABAB;

    &::after {
      position: relative;
      margin: 0 6px;
      color: #ff5050;
      content: "/";
    }

    &:last-child {
      &::after {
        content: "";
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// index.vue?03382fb2